(function($){

	$(document).ready(function(){
		posts_grid_jscroll();
		wrap_iframes();
		var scrollPos = 0;

		if(sessionStorage.getItem('pageviews')) {
			sessionStorage.setItem('pageviews', parseInt(sessionStorage.getItem('pageviews')) + 1);
		} else {
			sessionStorage.setItem('pageviews', 1);
		}

		// process_popup();

		// set all external links to open in new tab
	    $('a').each(function() {
	        var a = new RegExp('/' + window.location.host + '/');
	        if(!a.test(this.href)) {
	            $(this).prop('target','_blank');
	        }
	    });		

	    $(document).on('click','.menu-trigger',function(e){
			$('#mobile-menu').addClass('open');
		});

		$(document).on('click','.menu-close',function(e){
			$('#mobile-menu').removeClass('open');
		});

	    $(document).on('click','.accordion-trigger',function(e){
			$(this).parent().toggleClass('open');
			$(this).parent().find('.accordion-content').slideToggle();
		});


		$(document).on('click','.search-trigger',function(e){
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).siblings('.search-form').toggleClass('active');
			$(this).siblings('.search-form').find('.search-field').focus();
			$(this).siblings('.back-to-menu').addClass('active');
		});

		$(document).on('click','.back-to-menu',function(e){
			e.preventDefault();
			$(this).removeClass('active');
			$(this).siblings('.search-form').removeClass('active');
		});

		$(document).click(function(e){
			$is_search = (e.target.classList.contains('search-form') || e.target.classList.contains('search-field') || e.target.classList.contains('search-trigger'));

			if(!$is_search && $(window).width() > 991) {
				$('.search-form, .search-trigger').removeClass('active');
			}
		});

		$(document).on('click','.poster-img',function(e){
			e.preventDefault();
			stopAllVideos();

			$video_element = $(this).siblings('.iframe-wrapper').find('.yt-video');
			var $yt_video_id = $video_element.attr('id');

			$(this).siblings('.play-icon').fadeOut();
			$(this).fadeOut();
			eval($yt_video_id).playVideo();
		});

		$(document).on('click','.attentive-trigger',function(e){
			e.preventDefault();
			window.__attentive.trigger();
		});

		function stopAllVideos() {
			var playersSet = $('.yt-video');
			for (var i = 0; i < playersSet.length; i++) { 
				var aPlayer = playersSet[i]; 
		 		var aPlayerId = $(aPlayer).attr('id');
		 		eval(aPlayerId).pauseVideo();
			}
		}

		$('body').on('click','#mobile-menu ul li.menu-item-has-children',function(e){
			if(!$(this).hasClass('active')) {
				e.preventDefault();
				$(this).addClass('active');
				$(this).find('.sub-menu').slideDown();
			} else {
				$(this).removeClass('active');
				$(this).find('.sub-menu').slideUp();
			}
		});

		$('img.single-gallery-image').on('load',function(){
			$ga_label = this.dataset.galabel;

		  	gtag('event','Image View', {
		  		'event_category': 'Gallery Image Views',
		  		'event_label': $ga_label,
		  		'value': 1
		  	});
		});

		$(window).on('scroll',function(){
			var $site_header = $('#site-header');
			var $direction = 'up';

			if ((document.body.getBoundingClientRect()).top > scrollPos) {
				$direction = 'up';
			} else {
				$direction = 'down';
			}

			if($direction == 'up') {
				$site_header.removeClass('scroll');
			} else {

				if($site_header.length && $(window).scrollTop() >= 50 && !$site_header.hasClass('scroll') && $(window).width() > 991) {
					$site_header.addClass('scroll');
				}

				if($site_header.length && $(window).scrollTop() < 50 && $(window).width() > 991) {
					$site_header.removeClass('scroll');
				}
			}

			scrollPos = (document.body.getBoundingClientRect()).top;
		});


	    function posts_grid_jscroll() {
			if($('.posts--grid').length) {
				$('.posts--grid').jscroll({
					loadingHtml: '',
					loadingFunction: function() {
						$('.btn-loading-container').show();
					},
					nextSelector: '#posts--grid--next-page:last a.posts-next-link',
					contentSelector: '.posts--grid-content',
					autoTrigger: false,
					padding: 0,
					callback: function() {
						$('.btn-loading-container').hide();
					}
				});
			}
		}

		function wrap_iframes() {
			$('iframe[src*="vimeo"]').wrap("<div class='iframe-wrapper inline-vimeo'></div>");
			$('iframe[src*="youtube"]').wrap("<div class='iframe-wrapper inline-youtube'></div>");
		}


		// Bookmark on same page

		$('a[href*="#"]:not([href="#"])').click(function(e) {

			if(this.hash == '#subscribeModal') { return; }

	     	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		
	      		var target = $(this.hash);
	      
	      		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	      
		      	if (target.length) {
			        $('html,body').stop().animate({
			          scrollTop: target.offset().top - 200 //offsets for fixed header
			        }, 'linear');
			    }
	    	}
	  	});

		// Coming to bookmark from different page

		var hash= window.location.hash;
		if ( hash == '' || hash == '#' || hash == undefined || hash == '#subscribeModal' ) return false;

	    var target = $(hash);
	  	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	  
	  	if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 200 //offsets for fixed header
	        }, 'linear');
	    }

	});



	$(window).on('load',function(){
		if($('#sbi_images').find('.sbi_item').length) {
			instagram_slider();
		}

		if($('.trending-galleries__slider').length) {
			trending_galleries_slider();
		}

		if($('.shop-slider').length) {
			shop_sliders();
		}
	});

	function instagram_slider() {
		$('#sbi_images').each(function(index){
			var $prev_item = $(this).parent().parent().find('.slick-prev');
			var $next_item = $(this).parent().parent().find('.slick-next');

			if(!$(this).hasClass('slick-initialized')) {

				$(this).slick({
			        slidesToShow: 5.3,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        swipe: true,
			        prevArrow: $prev_item,
					nextArrow: $next_item,
					centerMode: true,
					initialSlide: 2,
					infinite: true,

					responsive: [
						{
					      breakpoint: 1600,
					      settings: {
					        slidesToShow: 4.3,
					        slidesToScroll: 1
					      }
					    },
					    {
					      breakpoint: 992,
					      settings: {
					        slidesToShow: 3,
					        slidesToScroll: 1
					      }
					    },
					    {
					      breakpoint: 768,
					      settings: {
					        slidesToShow: 2,
					        slidesToScroll: 1
					      }
					    }
				  	]
			    });  
			}
		});
	}

	function trending_galleries_slider() {
		$('.trending-galleries__slider').each(function(index){
			var $prev_item = $(this).siblings('.trending-galleries__navigation').find('.slick-prev');
			var $next_item = $(this).siblings('.trending-galleries__navigation').find('.slick-next');

			if(!$(this).hasClass('slick-initialized')) {

				$(this).slick({
			        slidesToShow: 5,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        swipe: true,
			        prevArrow: $prev_item,
					nextArrow: $next_item,
					infinite: true,

					responsive: [
						{
					      breakpoint: 1600,
					      settings: {
					        slidesToShow: 4,
					        slidesToScroll: 1
					      }
					    },
					    {
					      breakpoint: 1200,
					      settings: {
					        slidesToShow: 3,
					        slidesToScroll: 1
					      }
					    },
					    {
					      breakpoint: 768,
					      settings: {
					        slidesToShow: 1,
					        slidesToScroll: 1,
					        centerMode: true,
					        centerPadding: '75px',
							infinite: true,
							dots: true
					      }
					    }
				  	]
			    });  
			}
		});
	}


	function shop_sliders() {
		$('.shop-slider').each(function(index){
			var $prev_item = $(this).siblings('.shop-slider__navigation').find('.slick-prev');
			var $next_item = $(this).siblings('.shop-slider__navigation').find('.slick-next');

			if(!$(this).hasClass('slick-initialized')) {

				$(this).slick({
			        slidesToShow: 4.3,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        swipe: true,
			        prevArrow: $prev_item,
					nextArrow: $next_item,
					centerMode: true,
					centerPadding: '0px',
					initialSlide: 2,
					infinite: true,

					responsive: [
					    {
					      breakpoint: 1300,
					      settings: {
					        slidesToShow: 3.3,
					        slidesToScroll: 1
					      }
					    },
					    {
					      breakpoint: 768,
					      settings: {
					        slidesToShow: 1,
					        slidesToScroll: 1,
					        centerMode: true,
					        centerPadding: '125px',
							infinite: true,
					      }
					    },
					    {
					      breakpoint: 450,
					      settings: {
					        slidesToShow: 1,
					        slidesToScroll: 1,
					        centerMode: true,
					        centerPadding: '75px',
							infinite: true,
					      }
					    }
				  	]
			    });  
			}
		});
	}

	function process_popup() {

		if(sessionStorage.getItem('pageviews') == 1 || sessionStorage.getItem('pageviews') == 4) {
			
			setTimeout(function(){
				$('#subscribeModal').modal('show');
			}, 3000);
		}
	}
	
})(jQuery);